"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _react = _interopRequireDefault(require("react"));
var _moment = _interopRequireDefault(require("moment"));
var _typeModule = _interopRequireDefault(require("./type.module.scss"));
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }
function DateFomate(props) {
  var data = props.data;
  return /*#__PURE__*/_react["default"].createElement("div", {
    className: _typeModule["default"].wrapper
  }, (0, _moment["default"])(data).format('DD-MM-YYYY hh:mm a'));
}
var _default = DateFomate;
exports["default"] = _default;